var _path, _script;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiiaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.8308 47.9556C64.9994 47.9556 63.8031 46.7445 63.8031 44.9574C63.8031 43.1999 65.0142 42.0036 66.8308 42.0036H71.616V47.9556H66.8308ZM75.6185 38.5476H66.3582C62.4296 38.5476 59.7416 41.1174 59.7416 44.8097C59.7416 47.734 61.4105 49.9494 64.0542 50.7174L59.0031 58.4122H63.4782L68.0271 51.4116H71.6013V58.4122H75.6185V38.5476ZM25.5213 43.7611V37.7648H33.3047V54.7642H23.5422C24.5908 52.9328 25.5213 48.694 25.5213 43.7611ZM37.4253 33.9248H21.5484V43.9236C21.5484 49.019 20.6474 52.9919 19.4511 54.779H17.5459V63.8473H21.4745V58.486H36.3324V63.8473H40.261V54.779H37.4253V33.9248ZM49.4031 55.0448L49.0487 54.8085L53.6862 38.5476H44.3077L43.3034 42.166L48.7533 42.1217L45.2087 54.5279C44.5884 56.7876 46.1096 58.8848 48.5908 58.8848C49.3736 58.8848 50.1416 58.6928 50.9982 58.1464L57.3785 53.8337L55.429 50.9537L49.4031 55.0448ZM52.1207 34.811C54.0997 34.811 54.9268 34.0725 54.9268 32.315C54.9268 30.4836 54.0702 29.7451 52.1207 29.7451C50.1711 29.7451 49.3145 30.4836 49.3145 32.315C49.3293 34.0725 50.1416 34.811 52.1207 34.811Z",
    fill: "white"
  })), _script || (_script = /*#__PURE__*/React.createElement("script", {
    xmlns: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiiaLogo);
export default __webpack_public_path__ + "static/media/diia_logo.462a2f9fbb3a613162646b7a78804a0d.svg";
export { ForwardRef as ReactComponent };